export const getFirstName = (firstAndLastName: string): string => {
  const names = firstAndLastName.split(" ");
  return names.length > 0 ? names[0] : "";
};
